const SET_MASTER_CLASSES = (state, masterClasses) => {
    state.masterClasses = masterClasses;
};

const SET_ERROR = (state, error) => {
    state.error = error;
};

const SET_EVENTS = (state, {type, events}) => {
    let items = events.map(event => {
            return {
                id: event.id,
                slug: event.slug,
                label: event.name,
                endDate: event.endAt,
                certificateDownloadable: event.certificateDownloadable,
                invoiceDownloadable: event.invoiceDownloadable,
                type: event.type
            }
        });
        if (type.includes('summit')) {
            state.events.summit = items
        }
        if (type.includes('masterclass')) {
            state.events.masterclass = items
        }
};

export default {
    SET_EVENTS,
    SET_ERROR
}
